import makeStyles from "@material-ui/core/styles/makeStyles";

const styles = makeStyles((theme) => ({
  subheader: {
    fontSize: 18,
    fontFamily: "Roboto-Bold",
  },
  sliderContainer: {
    marginTop: 40,
    marginLeft: 30,
    marginRight: 30,
    height: 74,
    position: 'relative'
  },
  finIndicators: {
    border: '1px solid #B5BBC2',
    padding: 16,
    borderRadius: 16,
  },
  finIndicatorNumber: {
    fontSize: '1.2rem'
  },
  disabledReasonTooltip: {
    top: 40,
  }
}));

export default styles;